/**
 * @generated SignedSource<<d3738406b554386190b6102f240681f8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileAuctionDetails_nftItem$data = {
  readonly ownerAddress: {
    readonly address: string | null;
    readonly ensDomain: string | null;
    readonly publicProfile: {
      readonly profileName: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetailsFallback_nftItem">;
  readonly " $fragmentType": "NftItemTileAuctionDetails_nftItem";
};
export type NftItemTileAuctionDetails_nftItem$key = {
  readonly " $data"?: NftItemTileAuctionDetails_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileAuctionDetails_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "ownerAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ensDomain",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetailsFallback_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "b779b44eb861c721bea838b57a0b2a4c";

export default node;
